import { render, staticRenderFns } from "./allocations.vue?vue&type=template&id=706042fa&scoped=true&"
import script from "./allocations.vue?vue&type=script&setup=true&lang=js&"
export * from "./allocations.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./allocations.vue?vue&type=style&index=0&id=706042fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706042fa",
  null
  
)

export default component.exports